import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e19460b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "student-custom-column-edit-container" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "児童生徒のカスタム項目名の一覧です。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudentCustomColumnEditHeader = _resolveComponent("StudentCustomColumnEditHeader")!
  const _component_StudentCustomColumnEditTable = _resolveComponent("StudentCustomColumnEditTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StudentCustomColumnEditHeader, {
      class: "header",
      "is-admin": _ctx.isAdmin,
      editing: _ctx.editing,
      "on-click-back": _ctx.onClickBack,
      "on-click-edit": _ctx.startEditing,
      "on-click-cancel": _ctx.cancelEditing,
      "on-click-save": _ctx.save
    }, null, 8, ["is-admin", "editing", "on-click-back", "on-click-edit", "on-click-cancel", "on-click-save"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.tableModel != null)
        ? (_openBlock(), _createBlock(_component_StudentCustomColumnEditTable, {
            key: 0,
            class: "table",
            "custom-column-names": _ctx.tableModel,
            editing: _ctx.editing,
            "on-input": _ctx.onInput
          }, null, 8, ["custom-column-names", "editing", "on-input"]))
        : _createCommentVNode("", true)
    ])
  ]))
}